module.exports = {"id":"190752","name":"Jan Kirchhoff","rating":"75","photo":"./data/images/photos/4/190752.png","club":{"name":"Bolton","logo":"./data/images/clubs/Bolton.png"},"positions":["MDC","DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JanKirchhoff0.json
// module id = 1913
// module chunks = 0